import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .normalFont {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
  .cpm-container {
    // background: #ffffff;
    // min-height: 100vh;
    // font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    //   Ubuntu, Cantarell, sans-serif;
  }

  .cpm-calculator-card {
    border-radius: 16px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
  }

  .cpm-custom-input,
  .cpm-custom-select {
    height: 50px;
    border-radius: 10px !important;
    border: 1px solid #e5e7eb !important;
    padding: 0.75rem 1rem !important;
    font-size: 1rem !important;
    color: #1f2937 !important;
    background-color: #ffffff !important;
    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }

  .cpm-custom-input:focus,
  .cpm-custom-select:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
    outline: none !important;
  }

  .cpm-custom-input::placeholder {
    color: #6b7280 !important;
  }

  .cpm-custom-select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23374151' viewBox='0 0 16 16'%3E%3Cpath d='M8 12l-4-4h8l-4 4z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 12px;
  }

  .cpm-custom-button {
    height: 50px;
    border-radius: 10px !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out;
  }

  .cpm-custom-button:not(.cpm-secondary-button) {
    background-color: #8CC540 !important;
    border: none !important;
    color: #ffffff !important;
  }

  .cpm-custom-button:not(.cpm-secondary-button):hover {
    background-color: #8CC540 !important;
    transform: translateY(-2px);
  }

  .cpm-secondary-button {
    border: 1px solid #d1d5db !important;
    color: #374151 !important;
    background-color: #ffffff !important;
  }

  .cpm-secondary-button:hover {
    background-color: #f9fafb !important;
    transform: translateY(-2px);
  }

  .cpm-icon-wrapper {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cpm-text-primary {
    color: #3b82f6 !important;
  }

  .cpm-error-message {
    background-color: rgba(220, 38, 38, 0.1);
    border-left: 3px solid #dc2626;
  }

  .cpm-help-text {
    font-size: 0.875rem;
    color: #6b7280;
  }

  .cpm-result-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .cpm-result-row {
    min-height: 120px;
  }

  .cpm-result-row:nth-child(1) {
    background: linear-gradient(to bottom, #e2efff, #d1e4ff);
  }

  .cpm-result-row:nth-child(2) {
    background: linear-gradient(to bottom, #e5ffed, #d1f5e0);
  }

  .cpm-result-row:nth-child(3) {
    background: linear-gradient(to bottom, #f0faff, #e0f0ff);
  }

  .cpm-result-row:nth-child(4) {
    background: linear-gradient(to bottom, #ffefef, #ffe0e0);
  }

  .cpm-excellent {
    color: #059669 !important;
  }

  .cpm-good {
    color: #d97706 !important;
  }

  .cpm-poor {
    color: #dc2626 !important;
  }

  .cpm-recommendations-section {
    background-color: #f9fafb;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .cpm-recommendations-context {
    background-color: #eef2ff;
    border-left: 4px solid #4f46e5;
    color: #1f2937;
  }

  .cpm-recommendation-item {
    transition: background-color 0.2s ease-in-out;
  }

  .cpm-recommendation-item:hover {
    background-color: #f1f5f9;
  }

  .cpm-recommendation-number {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }

  .cpm-bg-light {
    background-color: #f8fafc !important;
  }

  .cpm-fs-2 {
    font-size: 2rem !important;
  }

  .cpm-fs-3 {
    font-size: 1.5rem !important;
  }

  .cpm-fs-4 {
    font-size: 1.25rem !important;
  }

  .cpm-fs-5 {
    font-size: 1.2rem !important;
  }
  .formCardResponsive {
    padding: 1.5rem;
  }
  .formCardResponsive1rem {
    padding: 1rem;
  }

  @media (max-width: 800px) {
    .formCardResponsive {
      padding: 0.5rem;
    }
    .formCardResponsive1rem {
      padding: 0rem;
    }
  }
  @media (max-width: 768px) {
    .cpm-container {
      padding: 1rem !important;
    }

    .cpm-fs-2 {
      font-size: 1.5rem !important;
    }

    .cpm-fs-3 {
      font-size: 1.25rem !important;
    }

    .cpm-fs-4 {
      font-size: 1rem !important;
    }

    .cpm-fs-5 {
      font-size: 1rem !important;
    }
  }
`;
